import { useEffect } from 'react';
import scrollLock from '../utils/scrollLock.js';
/**
 *
 * @param {*} isLocked
 * @returns
 */
export const useScrollLock = (isLocked = false) => {
  useEffect(() => {
    if (isLocked) {
      scrollLock.lock();
    } else {
      scrollLock.unlock();
    }

    // Cleanup on unmount
    return () => {
      scrollLock.unlock();
    };
  }, [isLocked]);

  return {
    lock: () => scrollLock.lock(),
    unlock: () => scrollLock.unlock(),
  };
};
